import { Sound } from "./Sound"

/**
 * To use words to lip sync you need to use an audio editing application, for example audacity, to determine the exact
 * start and end milliseconds for each word (or clump of words if they slur together). Then add a list of the main
 * sounds of the word. This won't include all the sounds, just the main ones, and needs to be done by sound.
 */
export class Word {
    start: number
    end: number
    sounds: Array<Sound> = []
    text: string

    /**
     *
     * @param {number} timing
     * @param {number} duration
     * @param {Array<Sound>} sounds
     * @param {string} text - Not used, but can be useful for debugging.
     */
    constructor(timing: number, duration: number, sounds: Array<Sound>, text: string) {
        this.start = timing
        this.end = duration
        this.sounds = sounds
        this.text = text
    }

    get duration(): number {
        return this.end - this.start
    }

    get soundDuration(): number {
        return this.duration / this.sounds.length
    }
}
